module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./MemCardBasticMsgView.js"));
	}, "MemCardMsgView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MemCardMsgView!./src/pages/Register/MemCardBasticMsg/MemCardBasticMsgView.js
// module id = 813
// module chunks = 438